import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { QuotaCleanerSelectors } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';
import type { QuotaCleanType } from 'reactApp/types/QuotaCleaner';
import { sendDwh } from 'reactApp/utils/ga';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';

export const useSendFastCleanRadar = ({ cleanType, category, name }: { cleanType?: QuotaCleanType; category: string; name: string }) => {
    const entryPoint = useSelector(QuotaCleanerSelectors.getEntryPoint);

    return useCallback(
        (action: string, restDwh?: { button_name?: string }) => {
            const dwhData = {
                name,
                ...(cleanType && { clean_type: cleanType }),
                platform: getPlatformInfo().join('_'),
                offer_source: entryPoint || 'none',
                ...restDwh,
            };

            const dwh_enabled_fields: (keyof typeof dwhData)[][] = [
                [
                    'name',
                    ...(cleanType ? ['clean_type' as const] : []),
                    ...(restDwh?.button_name ? ['button_name' as const] : []),
                    'platform',
                ],
            ];

            sendDwh({
                eventCategory: category,
                action,
                dwhData,
                dwh_enabled: true,
                dwh_enabled_fields,
            });
        },
        [cleanType, entryPoint]
    );
};
